export const SET_AWS_CREDENTIALS = 'SET_AWS_CREDENTIALS';
export const CLEAR_AWS_CREDENTIALS = 'CLEAR_AWS_CREDENTIALS';
